import { Language, MandantSettings } from '../types';
import { mandantSettings } from '../../Settings/mandants/mandant-settings';
import { defaultLanguage, defaultOrigin } from '../../Settings/config';
import { languages } from '../../Settings/data';
import { localeKey } from '../../App';

export const getMandantSettingsFromOrigin = (): MandantSettings => {
  const hostname: string = document.location.hostname;
  const domain: string = hostname.split('.').slice(-2).join('.');
  if (!domain) return getDefaultOriginMandantSettings();
  return getMandantSettingsByDomain(domain);
};

export function getDefaultOriginMandantSettings(): MandantSettings {
  const origin = localStorage.getItem('origin') || defaultOrigin;
  if(origin && mandantSettings.some((ms: MandantSettings): boolean => ms.mandant === origin)) {
    return mandantSettings.find((ms: MandantSettings): boolean => ms.mandant === origin);
  }
  return mandantSettings.find((ms: MandantSettings): boolean => ms.mandant === defaultOrigin);
}


export function getMandantSettingsByDomain(domain: string): MandantSettings {
  if (!domain) return getDefaultOriginMandantSettings();
  const mandantSetting: MandantSettings = mandantSettings.find((ms: MandantSettings): boolean => ms.domains.includes(domain));
  return mandantSetting ?? getDefaultOriginMandantSettings();
}

export function getCurrentLanguage(): Language {
  const storedLocale: string = window.localStorage.getItem(localeKey);
  if (storedLocale && languages.includes(storedLocale)) {
    return storedLocale;
  }
  const preferredLanguages: string[] = [...(navigator.languages || [navigator.language])];
  for (const preferredLanguage of preferredLanguages) {
    const lgCode: string = preferredLanguage.split('-')[0].replace('-', '').toLowerCase().trim();
    if (languages.includes(lgCode)) {
      return lgCode;
    }
  }
  return defaultLanguage;


}
